async function saveWallpaper(wallpaperId: string) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/saves/${wallpaperId}`;

  const res = await fetch(url, { method: "POST", credentials: "include" });
  const result: any = await res.json();

  const success = result.success ? true : false;
  return success;
}

export default saveWallpaper;
